import { useEffect, useState } from 'react'
import { TablePagination } from '../../../../../components/table'
import { useRESTapi } from '../../../../../hooks/rest_API'
import { Product, ProductItem, ProductKeys, StockItem, StockKeys, Store, pagination, Warehouse, WarehouseKeys, CustomerStock } from '../../../../../types'
import { AddEcomStockModal } from './component/addmodal'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/src/components/ui/table'
import { ButtonIcon } from '@/src/components/buttons/buttonIcon'
import { Pencil, Trash } from 'lucide-react'
import { Button } from '@/src/components/ui/button'
import { SkeletonTableAdmin } from '../../../components/skeltonTable'



type StockResponse = CustomerStock & {
  product_item: Partial<ProductItem>,
  // store: Partial<Store & Warehouse>
}

type StockOveview = {
  page_number: number,
  stockId: string | number,
  quantity: string | number,
  delete: any,
  edit: any,
  // imagePath:string,
  sku: any

}

type Props = {
  setSelectedId: (id: string) => any
}

export enum filterObjectTypeKeys {
  pageNo = 'pageNo'
}

export function EcommercStockCRUD(props: Props) {

  const [products, set_products] = useState<StockOveview[]>([])
  const [searchParams, setSearchParams] = useSearchParams();

  const [mode, set_mode] = useState<'edit' | 'add'>('add')
  const api = useRESTapi()
  const [update, setUpdate] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selected_product, set_selected_product] = useState<string>()
  const [page_selected, set_page_selected] = useState<number>(searchParams.get(filterObjectTypeKeys.pageNo) ? Number(searchParams.get(filterObjectTypeKeys.pageNo)) : 1)
  const [products_total, set_products_total] = useState<number>(1)
  const [per_page, set_per_page] = useState<number>(30)
  const navigate = useNavigate();
  const [isOrderLoading, setisOrderLoading] = useState(false)


  const header: {
    label: StockKeys | string,
    name: string
  }[] = [
      {
        label: 'page_number',
        name: "No"
      },
      // {
      //   label: 'stockId',
      //   name: "Id"
      // },
      {
        label: 'sku',
        name: "SKU"
      },
      {
        label: 'quantity',
        name: 'quantity'
      },
      // {
      //   label: 'edit',
      //   name: ''
      // },
      // {
      //   label: 'delete',
      //   name: ''
      // },
    ]

  const updateUi = () => {
    setUpdate(!update)
  }


  async function delete_product(id: number | string) {

    try {

      const res = await api.Delete<{ success: boolean, data: StockOveview[], message: string }>({
        url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/customer_stock/${id}`,
        mode: 'admin',

      })
      updateUi();
      if (res.data.success) {
        alert(res.data.message)
      } else {
        alert('somthing went wrong...')
      }


    } catch (error) {
      console.log(error)
    }

  }

  function clickEditButton(id: string) {
    set_selected_product(id)
    setShowModal(true)
    set_mode('edit')
  }
  function open_add_modal() {
    set_selected_product(undefined)
    setShowModal(true)
    set_mode('add')
  }

  useEffect(
    () => {

      props.setSelectedId('A7')
      const initData = async () => {
        setisOrderLoading(true)
        const res = await api.get<{ success: boolean, data: { data: StockResponse[] } & pagination }>({
          url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/customer_stock`,
          params: {
            perPage: per_page,
            page: page_selected
          },
          mode: 'admin',

        })

        if (res.data.success === true) {
          // console.log(res.data)
          set_products(res.data.data.data.map(
            (item, index) => {

              const stockOne: StockOveview = {
                page_number: ((page_selected - 1) * per_page) + (index + 1),
                quantity: item.I06_Available_quantity!,
                stockId: item.I06_I04_Stock_id!,
                delete: <ButtonIcon icon={<Trash className="h-4 w-4" />} onClick={() => delete_product(String(item.I06_Customer_Stock_id))}></ButtonIcon>,
                edit: <ButtonIcon icon={<Pencil className="h-4 w-4" />} onClick={() => clickEditButton(String(item.I06_Customer_Stock_id))}></ButtonIcon>,
                sku: (
                  <div className=' flex flex-col'>
                    <img className=' h-5 w-5' src={`${process.env.REACT_APP_BACKEND_URL}/${item?.product_item?.M08_ProductImage}`} />
                    <div>{item?.product_item?.M08_ProductItemName}</div>
                  </div>
                )
              }
              return stockOne;
            }
          ))
          set_products_total(res.data.data.total)
          setisOrderLoading(false)
        }

      }

      initData()

    }, [update]
  )

  return (
    <div className='  grow flex flex-col items-center  overflow-hidden py-5 gap-2 px-1 sm:px-5 '>
      <AddEcomStockModal
        id={selected_product}
        show={showModal}
        closeModal={() => setShowModal(false)}
        updateUi={updateUi}
        mode={mode}
        setShow={setShowModal}
      />
      <div className=' p-2 text-2xl font-bold'>Ecommerce Stock list</div>
      <div className=' w-full flex justify-end' >
        <Button onClick={open_add_modal} className=' '>Add Stock</Button>
      </div>
      <div className='grow overflow-auto  w-full border rounded-md'>
        {
          isOrderLoading
            ?
            <SkeletonTableAdmin />
            :
            <Table className=' w-full'>
              <TableHeader >
                <TableRow>
                  {
                    header.map(
                      (header, index) => <TableHead key={index}>{header.name}</TableHead>
                    )
                  }
                </TableRow>
              </TableHeader>
              <TableBody>
                {
                  products.length === 0
                    ?
                    'No data'
                    :
                    products.map(
                      (row: any, index) => (
                        <TableRow key={index}>
                          {
                            header.map(
                              (header, index) => <TableCell key={index}>{row[header.label]}</TableCell>
                            )
                          }
                        </TableRow>
                      )
                    )
                }
              </TableBody>
            </Table>
        }
      </div>
      <div>
        <TablePagination totalRows={products_total} rowsPerPage={per_page} onClickIndex={(e) => {
          set_page_selected(e);
          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.set(filterObjectTypeKeys.pageNo, e ? String(e) : '');
          navigate(`?${newSearchParams.toString()}`, { replace: true });
          updateUi()
        }} selectedPage={page_selected} />
      </div>
    </div>
  )
}
